const isEmpty = (value)=> {
    return (!value || !value.trim() ? true : false);
};

const isValidEmail = (value)=> {
    if(!value) return false;
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(!re.test(value.toLowerCase())) return false;
    return true;
};

const isValidFullname = (value)=> {
    if(!value) return false;
    if (value.trim().split(' ').length < 2) return false;
    return true;
};

const isValidCpf = (value)=> {
    const cpfStr = value.replace(/\D/g, '');
    if (
        !cpfStr ||
        cpfStr.length != 11 ||
        cpfStr == "00000000000" ||
        cpfStr == "11111111111" ||
        cpfStr == "22222222222" ||
        cpfStr == "33333333333" ||
        cpfStr == "44444444444" ||
        cpfStr == "55555555555" ||
        cpfStr == "66666666666" ||
        cpfStr == "77777777777" ||
        cpfStr == "88888888888" ||
        cpfStr == "99999999999" 
    ) {
        return false;
    }

    let sum = 0;
    let remainder = 0;

    for(let i = 1; i <= 9; i++) 
        sum = sum + parseInt(cpfStr.substring(i-1, i)) * (11 - i);
    remainder = (sum*10) %11;

    if((remainder == 10) || (remainder == 11)) remainder = 0;
    if(remainder != parseInt(cpfStr.substring(9, 10)) ) return false;
    sum = 0;
    for(let i = 1; i <= 10; i++) 
        sum = sum + parseInt(cpfStr.substring(i-1, i)) * (12 - i);
    remainder = (sum * 10) % 11;
    if ((remainder == 10) || (remainder == 11)) remainder = 0;
    if (remainder != parseInt(cpfStr.substring(10, 11) ) ) return false;

    return true;
}

const isValidCnpj = (value)=> {
    if(value == '') return false;
    value = value.replace(/\D/g, '');
     
    if (value.length != 14)
        return false;
 
    // Elimina CNPJs invalidos conhecidos
    if (value == "00000000000000" || 
        value == "11111111111111" || 
        value == "22222222222222" || 
        value == "33333333333333" || 
        value == "44444444444444" || 
        value == "55555555555555" || 
        value == "66666666666666" || 
        value == "77777777777777" || 
        value == "88888888888888" || 
        value == "99999999999999")
        return false;
         
    let size = value.length - 2;
    let nums = value.substring(0,size);
    let digits = value.substring(size);

    let sum = 0;
    let pos = size - 7;
    for(let i = size; i >= 1; i--) {
      sum += parseInt(nums.charAt(size - i)) * pos--;
      if (pos < 2)
            pos = 9;
    }
    let result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if(result != parseInt(digits.charAt(0)))
        return false;
         
    size = size + 1;
    nums = value.substring(0,size);
    sum = 0;
    pos = size - 7;
    for(let i = size; i >= 1; i--) {
      sum += parseInt(nums.charAt(size - i)) * pos--;
      if (pos < 2)
            pos = 9;
    }
    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result != parseInt(digits.charAt(1)))
          return false;
           
    return true;
}

const isValidPhone = (value)=> {
    if(!value) return false;
    const cleanPhoneStr = value.replace(/[\)\(\- \+]/g, '');
    if(/\D+/.test(cleanPhoneStr)) return false;
    if(cleanPhoneStr.length > 13 || cleanPhoneStr.length < 10) return false;
    return true;
}

const applyErrorStyle = (fieldEl)=> {
    const labelEl = fieldEl.previousElementSibling;
    fieldEl.classList.add('form__input--err');
    labelEl.classList.add('form__label--err');
}

const removeErrorStyle = (fieldEl)=> {
    const labelEl = fieldEl.previousElementSibling;
    fieldEl.classList.remove('form__input--err');
    labelEl.classList.remove('form__label--err');
}

export const handleCnpjCpfField = (cnpjField)=> {
    const cnpjEl = cnpjField.el;
    cnpjEl.addEventListener('input', ()=> {
        if(cnpjEl.value.length > 14) {
            const cleanCnpj = cnpjEl.value.slice(0, 18).replace(/\D/g, '');
            cnpjEl.value = cleanCnpj.replace(/(\d{1,2})(\d{1,3})(\d{1,3})(\d{1,4})(\d{1,2})/g,
                '$1.$2.$3/$4-$5').slice(0, 18);
            if(!isValidCnpj(cnpjEl.value)) {
                applyErrorStyle(cnpjEl);
                cnpjField.isValid = false;
            }
            else {
                removeErrorStyle(cnpjEl);
                cnpjField.isValid = true;
            }
        }
        else {
            const cleanCpf = cnpjEl.value.replace(/\D/g, '');
            cnpjEl.value = cleanCpf.replace(/(\d{1,3})(\d{1,3})(\d{1,3})(\d{1,2})/g,
                '$1.$2.$3-$4');

            if(!isValidCpf(cnpjEl.value)) {
                applyErrorStyle(cnpjEl);
                cnpjField.isValid = false;
            }
            else {
                removeErrorStyle(cnpjEl);
                cnpjField.isValid = true;
            }

        }
    });
};

export const handlePhoneField = (phoneField)=> {
    const phoneEl = phoneField.el;
    phoneEl.addEventListener('input', ()=> {
        const cleanPhone = phoneEl.value.slice(0, 15).replace(/\D/g, '');
        phoneEl.value = cleanPhone.replace(/(\d{2})(\d{1,4})(\d{1,5})/g, '($1) $2-$3').slice(0, 15);
        if(!isValidPhone(phoneEl.value)) {
            applyErrorStyle(phoneEl);
            phoneField.isValid = false;
        }
        else {
            removeErrorStyle(phoneEl);
            phoneField.isValid = true;
        }
    });
}

export const handleGenericField = (field)=> {
    const fieldEl = field.el;
    fieldEl.addEventListener('input', ()=> {
        fieldEl.value = fieldEl.value.slice(0, 100);
        if(isEmpty(fieldEl.value) && field.required) {
            applyErrorStyle(fieldEl);
            field.isValid = false;
        }
        else {
            removeErrorStyle(fieldEl);
            field.isValid = true;
        }
    });
}

export const handleFullnameField = (field)=> {
    const fieldEl = field.el;
    fieldEl.addEventListener('input', ()=> {
        fieldEl.value = fieldEl.value.slice(0, 100);
        if(!isValidFullname(fieldEl.value) && field.required) {
            applyErrorStyle(fieldEl);
            field.isValid = false;
        }
        else {
            removeErrorStyle(fieldEl);
            field.isValid = true;
        }
    });
}

export const handleEmailField = (emailField)=> {
    const emailEl = emailField.el;
    emailEl.addEventListener('input', ()=> {
        emailEl.value = emailEl.value.slice(0, 100);
        if(!isValidEmail(emailEl.value)) {
            applyErrorStyle(emailEl);
            emailField.isValid = false;
        }
        else {
            removeErrorStyle(emailEl);
            emailField.isValid = true;
        }
    });
}

export const checkFirstPageFieldsValidations = (form)=> {
    const firstPageFields = [
        'cnpj',
        'phone',
        'name',
        'email',
    ];

    for(const [fieldName, field] of Object.entries(form)) {
        if(!field.isValid && firstPageFields.includes(fieldName)) {
            return false;
        }
    }
    return true;
};

export const checkAllFieldsValidations = (form)=> {
    for(const field of Object.values(form)) {
        if(!field.isValid) {
            return false;
        }
    }
    return true;
};

export const clearForm = (form)=> {
    for(const field of Object.values(form)) {
        field.el.value = '';
        field.isValid = false;
    }
};

export const setFormLoader = ()=> {
    const el = document.getElementById('form-loader');
    el.classList.remove('form--loader-hidden');
};

export const removeFormLoader = ()=> {
    const el = document.getElementById('form-loader');

    el.classList.add('form--loader-hidden');
};
